import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Calculator, FileText } from "lucide-react";

interface WelcomeSectionProps {
  latestCalculation: any;
  savingsMessage: string;
}

export const WelcomeSection = ({ latestCalculation, savingsMessage }: WelcomeSectionProps) => {
  const navigate = useNavigate();
  
  return (
    <Card className="p-8 bg-primary/10 border-primary/20">
      <h2 className="text-2xl font-semibold text-foreground mb-4">
        Welcome to Your Financial Freedom Journey
      </h2>
      <p className="text-muted-foreground mb-4">
        Follow these simple steps to reduce your monthly obligations and start saving more. 
        Complete the process within 24 hours to qualify for an additional 5% reduction!
      </p>
      <p className="text-lg font-bold text-primary">
        <span className="block mb-2">You can be helped within 7 days - no stress, no pressure, just more money in your pocket.</span>
        {savingsMessage}
      </p>
      {latestCalculation && (
        <div className="mt-6 p-6 bg-green-500/10 border border-green-500/20 rounded-lg">
          <p className="text-green-400 font-semibold">
            Ready to proceed? Send us your documents and we'll start working on your case immediately!
          </p>
          <Button 
            onClick={() => navigate('/dashboard/documents')}
            className="mt-4 bg-green-500 hover:bg-green-600 text-white"
          >
            Upload Documents Now →
          </Button>
        </div>
      )}
    </Card>
  );
};